import {FormPost, GET, POST} from "../util";

const loginUrl = "api/login/";

const auth = "api/auth/";
const url = {
    user: {
        LoginApi: "api/login",

        logout: `${auth}logout`,
        setPassword: `${loginUrl}setPassword`,
        checkToken: `${loginUrl}checkToken`,
        requestLoginHelp: `${loginUrl}requestLoginHelp`
    }
};
const userApi = {
    RequestLoginHelp: (params = {}) => {
        return POST(url.user.requestLoginHelp, params, "application/json", 'String');
    },
    Login: (params = {}) => {
        return FormPost(url.user.LoginApi, params);
    },
    Logout: (params = {}) => {
        return GET(url.user.logout, params);
    },
    SetPassword: (params = {}) => {
        return POST(url.user.setPassword, params);
    },
    CheckToken: (params = {}) => {
        return POST(url.user.checkToken, params);
    }
};
export {
    userApi
};